import React, { useEffect, useState, useContext } from "react";
import Lottie from "react-lottie-player";
import IDScan from "../assets/id-scan-loading.json";
import { Text, Stack, Progress, Box } from "@mantine/core";
import { DataContext } from "../context/DataContext";
const getAnimationData = (type) => {
  switch (type) {
    case "documentVerification":
      return { animation: IDScan, message: "Checking your document..." };
    case "documentVerificationLongDuration":
      return {
        animation: IDScan,
        message: "This may take up to 90 seconds to complete. Please wait...",
        longDuration: true,
      };
    // Add more cases as needed
    default:
      return { animation: IDScan, message: "Loading..." };
  }
};

export default function VerificationLoadingScreen({ type }) {
  const { animation, longDuration } = getAnimationData(type);
  const [progress, setProgress] = useState(0);
  const { text, data, settings } = useContext(DataContext);

  const browserLanguage = typeof navigator !== "undefined" ? navigator.language : "";
  const language = (
    data?.language ||
    settings?.language ||
    settings?.text?.language ||
    text?.language ||
    text?.lang ||
    browserLanguage
  )?.toLowerCase();
  const isEnglish = language?.startsWith("en");

  const title = text.loading?.document_verification?.title ?? (isEnglish ? "Processing Verification" : "");
  const subtitle = text.loading?.document_verification?.subtitle || text.loading?.verify || "";

  useEffect(() => {
    if (longDuration) {
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 1.6667; // 100% / 60 seconds
        });
      }, 1000); // update every second

      return () => clearInterval(interval);
    }
  }, [longDuration]);

  return (
    <Box style={{ width: '100%' }}>
      {longDuration && (
        <Box style={{ position: 'sticky', top: 0, width: '100%', zIndex: 1000 }}>
          <Progress value={progress} animate />
        </Box>
      )}
      <Stack spacing={20} mt={longDuration ? 20 : 0} align="flex-start" style={{ width: '100%' }}>
        <Stack spacing={8} px="lg" style={{ width: '100%' }}>
          <Text size="xl" weight={700} align="left">
            {title}
          </Text>
          <Text size="md" c="dimmed" align="left">
            {subtitle}
          </Text>
        </Stack>
        <Box style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Lottie
            animationData={animation}
            loop={true}
            play
            style={{ height: 100 }}
          />
        </Box>
      </Stack>
    </Box>
  );
}
